import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';
import { TextSelection } from '../../../../../models/text-selection';
import { PageTextService } from '../../../../../services/page-text.service';
import { Page } from '../../../../../models/page';
import { environment } from '../../../../../../environments/environment';
import { ApplicationStateService } from '../../../../../services/application-state.service';

@Component({
    selector: 'app-page-text-selection',
    templateUrl: './page-text-selection.component.html',
    styleUrls: ['./page-text-selection.component.scss'],
    standalone: true
})
export class PageTextSelectionComponent implements AfterViewInit {

    @Input() textSelection: TextSelection;
    @Input() page: Page;
    crudPermitted = environment.features.rectsActivated;
    offlineModeDisabled;

    constructor(public applicationStateService: ApplicationStateService,
                private textSelectionService: PageTextService,
                private changeDetectorRef: ChangeDetectorRef) {
        this.offlineModeDisabled = !this.applicationStateService.isOfflineModeEnabled;
    }

    ngAfterViewInit(): void {
        this.changeDetectorRef.detach();
    }

    deleteSelection(): void {
        this.textSelection.isDeleted = true;

        if (this.textSelection.textBoxes) {
            this.textSelection.textBoxes.forEach(ele => {
                ele.isHighlighted = false;
            });
        }

        this.textSelectionService.removeTextSelection(this.textSelection);
    }
}
